import CalendarAltRegular from '@alefeducation/ui-elements-library-icons/lib/components/Icons/CalendarAltRegular'
import { Text } from '@alefeducation/ui-elements-library-core/lib/Text'
import React from 'react'
import { theme } from '@alefeducation/ui-elements-library-core'
import { TimesCircle } from '@alefeducation/ui-elements-library-icons'
import { StyledDateButton } from './DatePicker.styled'
import { DateTuple } from './DatePicker'

const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']

const getOrdinal = (n: number) => {
  switch (n) {
    case 1:
    case 21:
    case 31:
      return 'st'
    case 2:
    case 22:
      return 'nd'
    case 3:
    case 23:
      return 'rd'
    default:
      return 'th'
  }
}

export const getDateString = (date: Date) => {
  if (!date) {
    return '*'
  }
  const day = date.getDate()
  const month = date.getMonth()
  const year = date.getFullYear()
  return `${day}${getOrdinal(day)} ${monthNames[month]}, ${year}`
}

export type DatePickerButtonProps = {
  id?: string
  value: DateTuple
  onClear: () => void
  onClick?: () => void
  disabled?: boolean
}

export const DatePickerButton = ({ id, value, onClear, onClick, disabled }: DatePickerButtonProps) => {
  return (
    <StyledDateButton
      style={{
        boxShadow: `0 0 0 1px ${theme.colors.primary[20]}`
      }}
      id={id}
      disabled={disabled}
    >
      <div
        onClick={onClick}
        data-testid="date-picker-label-button"
        onKeyDown={e => {
          if (e.key === 'Enter') {
            onClick()
          }
        }}
      >
        <CalendarAltRegular color="primary.40" />
        <Text variant="body-large" weight="light" color="primary.100">
          {value[0] || value[1] ? `${getDateString(value[0])} - ${getDateString(value[1])}` : '--Select range--'}
        </Text>
      </div>
      {value[0] || value[1] ? (
        <TimesCircle
          data-testid="clear-date-picker-icon"
          color="primary.40"
          onClick={() => {
            onClear()
          }}
        />
      ) : null}
    </StyledDateButton>
  )
}
